export default __webpack_public_path__ + "static/media/blog5.90fe9441.png";